import CatalogService from "@/models/catalog.service";
import Bill from "@/models/bill";

export default class Service {
    //@ts-ignore
    public id: string;
    public price: number;    
    public serviceId: string;
    public billId?: string;
    public isChecked: boolean;    

    public service: CatalogService;
    //@ts-ignore
    public bill: Bill;

    constructor(service: CatalogService)
    {        
        this.service = service;
        this.price = service.price || 0;
        this.serviceId = service.id;
        this.isChecked = true;
    }
}
